import { notFound } from 'next/navigation'
import { getRequestConfig } from 'next-intl/server'

import { getMessages } from '@/utils'
import { TLang } from '@/types'

import { routing } from './routing'

export default getRequestConfig(async ({ requestLocale }) => {
  let locale = await requestLocale
  // Validate that the incoming `locale` parameter is valid
  if (!routing.locales.includes(locale as any)) notFound()
  return {
    locale,
    timeZone: 'UTC',
    messages: await getMessages(locale as TLang),
  }
})
